<section class="top">
    @if (isDemo) {
        <div class="update-bar demo-banner">
            <img src="assets/icons/demo-icon-banner.svg" alt="Demo mode icon" class="demo-icon" />
            <span class="demo-text">Demo mode</span>
        </div>
    }

    @if (displayUpdateBar) {
        <div class="update-bar">
            @if (majorUpdate) {
                <div>{{ "misc.majorUpdate" | translate }} {{ secondsToSignOut }} {{ "misc.majorUpdate_2" | translate }}</div>
            } @else if (minorUpdate) {
                <div>
                    {{ "misc.minorUpdate" | translate }} <a href="javascript:void(0);" (click)="refreshWindow()">{{ "misc.click_to" | translate }}</a> {{ "misc.to_refresh" | translate }}
                </div>
            }
        </div>
    }

    @if (maintenanceService.maintenanceWillBegin()) {
        <div class="update-bar scheduled">
            {{ "navbar.maintenance_1" | translate }}
            {{ maintenanceService.maintenanceCountdown() | translate }}
            {{ "navbar.maintenance_2" | translate }}
        </div>
    }

    @if (adminService.controlActive() && !adminService.loadingControlledUid()) {
        <div class="update-bar control">
            <span>
                Controlling <strong>{{ authenticatedUser.name }}'s</strong> account
            </span>
        </div>
    }

    <section class="topbar" [class.topbar-hidden]="!sidebarService.isBelowTabletWidth()">
        @if (sidebarService.isBelowMobileWidth()) {
            @if (!mobileSearchOpen()) {
                <div class="topbar-start">
                    <div class="topbar-start-header-logo">
                        <div class="topbar-start-header-logo-img" (click)="sidebarService.disableSidebar()" [routerLink]="['/home']">
                            <img src="assets/icons/dashboard-logo.svg" alt="Airwallet Logo" />
                            @if (dashboardOwnerUser.operatorName) {
                                <div class="topbar-start-header-logo-img-operator">
                                    <app-aw-tooltip [tooltipTitle]="'navbar.main_operator' | translate">
                                        <ng-container tooltip_element_ref>
                                            <img width=".875rem" height="auto" src="assets/icons/operator-notify-icon.svg" alt="Info" />
                                        </ng-container>

                                        <ng-container description>
                                            <div>
                                                <span style="font-weight: 600"> {{ dashboardOwnerUser.operatorName }} </span>{{ "navbar.main_operator_description_long_pt1" | translate }}
                                            </div>
                                            <div class="mt-2">
                                                {{ "navbar.main_operator_description_long_pt2" | translate }}
                                            </div>
                                            <div class="mt-2">
                                                {{ "navbar.main_operator_description_long_pt3" | translate }}
                                                {{ dashboardOwnerUser.operatorName }}
                                                {{ "navbar.main_operator_description_long_pt4" | translate }}
                                            </div>
                                        </ng-container>
                                    </app-aw-tooltip>
                                </div>
                            }
                        </div>
                        <div class="topbar-start-header-logo-titles">
                            @if (samlService.samlMembershipOwners()) {
                                <app-owner-selector />
                            } @else {
                                <div class="ellipsis">
                                    <span>
                                        @if (isDemo) {
                                            <strong [title]="'navbar.demo_acc' | translate">{{ "navbar.demo_acc" | translate }}</strong>
                                        } @else {
                                            <strong [title]="dashboardOwnerUser.company_name">{{ dashboardOwnerUser.company_name }}</strong>
                                        }
                                    </span>
                                </div>
                            }
                            <div class="ellipsis" [title]="authenticatedUser.name">
                                <span style="font-size: 12px">{{ authenticatedUser.name }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="topbar-start-search">
                        <app-search-bar />
                    </div>
                </div>
                <div class="topbar-end">
                    <img src="assets/icons/burger.svg" alt="Burger Icon" class="topbar-burger topbar-btn" (click)="sidebarService.enableSidebar()" />
                    @if (isAdmin()) {
                        <img src="assets/icons/admin.svg" alt="Burger Icon" class="topbar-btn" (click)="sidebarService.enableAdminSidebar()" />
                    }
                </div>
            } @else {
                <div class="topbar-only-search">
                    <app-search-bar />
                </div>
            }
        } @else {
            <img src="assets/icons/burger.svg" alt="Burger Icon" class="topbar-burger topbar-btn" (click)="sidebarService.enableSidebar()" />
            <div class="topbar-header">
                <img src="assets/icons/dashboard-logo.svg" alt="Airwallet Logo" [routerLink]="['/home']" />
                <div>
                    <div class="topbar-header-company">
                        <strong [title]="dashboardOwnerUser.company_name">{{ dashboardOwnerUser.company_name }}</strong>
                    </div>
                    <div class="topbar-header-name" [title]="authenticatedUser.name">{{ authenticatedUser.name }}</div>
                </div>
            </div>

            @if (isAdmin()) {
                <img src="assets/icons/admin.svg" alt="Burger Icon" class="topbar-btn" (click)="sidebarService.enableAdminSidebar()" />
            }
        }
    </section>
</section>
